




















































































































































































import Vue from 'vue';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import * as val from '../../base/validations';
import routerService from '../../base/router-service';
import { Prop } from 'vue-property-decorator';
import { VueMaskDirective } from 'v-mask';
import licencaService from './licenca-service';
import empresaService from '../empresa/empresa-service';
import produtoService from '../produto/produto-service';
Vue.directive('mask', VueMaskDirective);
import { obterDiaMesAnoPadraoBR } from "../../utils/utils";
import usuarioService from "../usuario/usuario-service";
import areaService from '../area-atual/area-service';

@Component
export default class LicencaInserirEditar extends Vue {
    @Prop() licencaId: string;
    @Prop() visualizando: boolean;
    licenca: Api.App.Server.Licenca.InserirEditar.Command = {
        id: null,
        produtoId: null,
        valorUnitario: null,
        quantidade: null,
        total: null,
        situacao: null,
        empresaId: null,
        situacaoPagamento: null,
        usuarioId: null,
        situacaoPagamentoAtualizadaEm: null,
        gatewayAtualizadoEm: null,
        ativadoEm: null,
        inativadoEm: null
    };
    licencaCabecalho: Api.App.Server.Licenca.InserirEditar.Command = null;
    empresas: Api.App.Server.Empresa.Listar.EmpresaDto[] = [];
    produtos: Api.App.Server.Produto.Listar.ProdutoDto[] = [];
    usuario: any[] = [];
    obterDiaMesAnoPadraoBR = obterDiaMesAnoPadraoBR;
    areaAtual: string = null;

    get acao() {
        let result = 'Inserindo';
        if (this.visualizando) {
            result = 'Visualizando';
        } else if (this.licencaId) {
            result = 'Alterando';
        }

        return result + ' Licença';
    }

    get carregando() {
        return !this.licenca;
    }

    get licencaComErro() {
        return (
            this.licenca &&
            this.licenca.situacaoPagamento ==
            Api.Common.Domain.SituacaoPagamentoEnum.Falha
        );
    }

    get ativo() {
        return (
            this.licenca &&
            this.licenca.situacao == Api.Common.Domain.SituacaoEnum.Ativo
        );
    }

    async abrirAssinaturas() {
        await routerService.goTo('usuario-editar', {
            usuarioId: this.licenca.usuarioId,
        });
    }

    private async listarEmpresas() {
        const { itens } = await empresaService.listar({});
        this.empresas = itens;
    }

    async ativar() {
        this.$action.processAction({
            action: async () => {
                await licencaService.ativar({ licencaId: this.licencaId });

                this.$snackbars.open({
                    text: 'Licença ativada com sucesso!',
                    color: 'success',
                });

                await routerService.goTo('licenca-listar');
            },
            showSnackbar: false,
        });
    }

    async inativar() {
        this.$action.processAction({
            action: async () => {
                await licencaService.inativar({
                    licencaId: this.licencaId,
                });

                this.$snackbars.open({
                    text: 'Licença inativada com sucesso!',
                    color: 'success',
                });

                await routerService.goTo('licenca-listar');
            },
            showSnackbar: false,
        });
    }

    async empresaIdOnChange(value) {
        this.licenca.empresaId = value;
    }

    obterRazaoSocial(id: string) {
        if (!this.empresas) {
            return '';
        }

        const empresa = this.empresas.find((p) => p.id == id);
        if (empresa) {
            return empresa.razaoSocial;
        }
    }

    situacaoPagamentoAtualizadaEm(situacao: any) {
        switch (+situacao) {
            case Api.Common.Domain.SituacaoEnum.Ativo: {
                return "Ativo";
            }

            case Api.Common.Domain.SituacaoEnum.Inativo: {
                return "Inativo";
            }
        }
    }

    situacaoPagamento(situacao: any) {
        switch (+situacao) {
            case Api.Common.Domain.SituacaoPagamentoEnum.Sucesso: {
                return "Sucesso";
            }

            case Api.Common.Domain.SituacaoPagamentoEnum.Falha: {
                return "Falha";
            }

            case Api.Common.Domain.SituacaoPagamentoEnum.Processando: {
                return "Processando";
            }

            case Api.Common.Domain.SituacaoPagamentoEnum.NaoIniciado: {
                return "Não Iniciado";
            }

            case Api.Common.Domain.SituacaoPagamentoEnum.Estornado: {
                return "Estornado";
            }

        }
    }

    private async listarProdutos() {
        const { itens } = await produtoService.listar({});
        this.produtos = itens;
    }

    async produtoIdOnChange(value) {
        this.licenca.produtoId = value;
    }

    obterNomeProduto(id: number) {
        if (!this.produtos) {
            return '';
        }

        const produto = this.produtos.find((p) => p.id == id);
        if (produto) {
            let result = produto.titulo;
            if (produto.subtitulo) {
                result += ` - ${produto.subtitulo}`;
            }

            return result;
        }
    }

    async listarUsuarios() {
        let usuario = await usuarioService.listar({
            tipo: Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Todos
        });

        let result = [];

        for (let item of usuario.itens) {
            result.push({
                id: item.id,
                nome: item.nome
            })
        }

        this.usuario = result;
    }

    obterNomeUsuario(id: number) {
        if (!this.usuario)
            return "";

        let usuario = this.usuario.find(p => p.id == id);
        if (usuario) {
            return usuario.nome;
        }
    }

    recalcularTotal() {
        this.licenca.total =
            this.licenca.valorUnitario * this.licenca.quantidade;
    }

    voltar() {
        routerService.goBack();
    }

    async cancelar() {
        const cancelado = await this.$confirm.open({
            title: 'Cancelar',
            message: 'Deseja realmente cancelar a operação ?',
        });

        if (cancelado) {
            this.$snackbars.open({
                text: 'Ação cancelada!',
                color: 'success',
            });

            await routerService.goTo('licenca-listar');
        }
    }

    async obterParaEditar() {
        this.licenca = await licencaService.obterParaEditar({
            id: this.licencaId,
        });

        this.licenca.ativadoEm = obterDiaMesAnoPadraoBR(this.licenca.ativadoEm);
        this.licenca.gatewayAtualizadoEm = obterDiaMesAnoPadraoBR(this.licenca.gatewayAtualizadoEm);
        this.licenca.situacaoPagamentoAtualizadaEm = obterDiaMesAnoPadraoBR(this.licenca.situacaoPagamentoAtualizadaEm);
        this.licenca.inativadoEm = obterDiaMesAnoPadraoBR(this.licenca.inativadoEm);
    }

    async carregarDados() {
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.licencaId) {
            await this.obterParaEditar();
            await this.listarEmpresas();
            await this.listarProdutos();
            await this.listarUsuarios();
        }
    }

    created() {
        this.carregarDados();
    }
}
